export const NO_COMSA_FIRST_PAYOUT_MAX_AMOUNT_USD = 25;
export const COMSA_FEE_PERCENT = 10;

export const WITHDRAWAL_PHASES = {
    FILL_FORM: 'fill_form',
    TRANSFER: 'transfer',
} as const;

export const WITHDRAWAL_TRANSFER_STATUS = {
    LOADING: 'loading',
    PENDING: 'pending',
    SUCCESS: 'success',
    FAILURE: 'failure',
} as const;

export const WITHDRAWAL_TRANSFER_LOADING_STEP_LIST = [
    'checking_data',
    'processing_transaction',
    'generating_data',
    'sending_request',
];

export const MAP_WITHDRAWAL_STATUS_TO_ANIMATION_NAME = {
    [WITHDRAWAL_TRANSFER_STATUS.LOADING]: 'CircleFill',
    [WITHDRAWAL_TRANSFER_STATUS.SUCCESS]: 'CircleCheckMark',
    [WITHDRAWAL_TRANSFER_STATUS.PENDING]: 'CircleClock',
    [WITHDRAWAL_TRANSFER_STATUS.FAILURE]: 'CircleError',
}

export const WITHDRAWAL_AMOUNT_FIELD_ERRORS = [
    'error.max_withdraw',
    'error.max_withdraw_per_day',
    'error.max_withdraw_per_month',
    'error.max_withdraw_per_week',
    'error.min_withdraw',
    'error.withdrawal_amount',
];
